document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('[data-eu-withdrawal-root]');

  roots.forEach((root) => {
    const isWithdrawalPage = root.dataset.isWithdrawalPage === 'true';
    const form = root.querySelector('#EuWithdrawalForm');
    const step1 = root.querySelector('[data-step="1"]');
    const step2 = root.querySelector('[data-step="2"]');
    const goStep2 = root.querySelector('[data-go-step-2]');
    const backStep1 = root.querySelector('[data-back-step-1]');
    const summary = root.querySelector('[data-summary]');
    const submitBtn = root.querySelector('[data-submit-withdrawal]');
    const confirmCheck = root.querySelector('#withdrawal_confirm_check');
    const message = root.querySelector('[data-withdrawal-message]');

    function showStep(stepNumber) {
      if (!step1 || !step2) return;
      step1.hidden = stepNumber !== 1;
      step2.hidden = stepNumber !== 2;
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    if (isWithdrawalPage) {
      showStep(1);
    }

    goStep2?.addEventListener('click', () => {
      if (!form || !form.reportValidity()) return;

      const data = new FormData(form);
      summary.innerHTML = `
        <p><strong>Ime i prezime:</strong> ${escapeHtml(data.get('name'))}</p>
        <p><strong>E-mail:</strong> ${escapeHtml(data.get('email'))}</p>
        <p><strong>Broj narudžbe / ugovora:</strong> ${escapeHtml(data.get('order_number'))}</p>
        <p><strong>Telefon:</strong> ${escapeHtml(data.get('phone'))}</p>
        <p><strong>Datum narudžbe:</strong> ${escapeHtml(data.get('order_date'))}</p>
        <p><strong>Datum primitka robe:</strong> ${escapeHtml(data.get('delivery_date'))}</p>
        <p><strong>Proizvodi:</strong> ${escapeHtml(data.get('items'))}</p>
        <p><strong>Razlog:</strong> ${escapeHtml(data.get('reason'))}</p>
      `;
      showStep(2);
      message.textContent = '';
      message.className = 'eu-withdrawal-message';
    });

    backStep1?.addEventListener('click', () => {
      showStep(1);
      message.textContent = '';
      message.className = 'eu-withdrawal-message';
    });

    submitBtn?.addEventListener('click', async () => {
      if (!confirmCheck.checked) {
        message.textContent = 'Morate potvrditi zahtjev za odustajanje.';
        message.className = 'eu-withdrawal-message is-error';
        return;
      }

      const endpoint = submitBtn.dataset.endpoint;
      const data = new FormData(form);
      data.append('withdrawal_confirmed', 'true');
      data.append('submitted_at', new Date().toISOString());

      try {
        submitBtn.disabled = true;

        const response = await fetch(endpoint, {
          method: 'POST',
          body: data
        });

        if (!response.ok) {
          throw new Error('Greška pri slanju zahtjeva.');
        }

        message.textContent = 'Zahtjev je uspješno zaprimljen. Potvrda će biti poslana na vašu e-mail adresu.';
        message.className = 'eu-withdrawal-message is-success';
        form.reset();
        showStep(1);
      } catch (error) {
        message.textContent = 'Došlo je do greške. Pokušajte ponovno ili nas kontaktirajte e-mailom.';
        message.className = 'eu-withdrawal-message is-error';
      } finally {
        submitBtn.disabled = false;
      }
    });
  });
});